import { render, staticRenderFns } from "./PartCostTableContainer.vue?vue&type=template&id=2630dcd5&"
import script from "./PartCostTableContainer.vue?vue&type=script&lang=js&"
export * from "./PartCostTableContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports